export default __webpack_public_path__ + "static/thimk-618f32a682377d10c785131e0890b6fb.svg";